exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1xGL15MkbsCj_IGKiPYW8I{display:inline-block;margin-right:12px;font-size:14px}._1xGL15MkbsCj_IGKiPYW8I:last-child{margin-right:0}", ""]);

// exports
exports.locals = {
	"rating": "_1xGL15MkbsCj_IGKiPYW8I"
};